import React from 'react';
import { Rocket, BookOpen, Camera, Factory, DollarSign, TrendingUp, Check } from 'lucide-react';
import { motion } from 'framer-motion';
const tomos = [{
  num: 1,
  title: 'NEGOCIO DESDE CERO',
  subtitle: 'Arrancá esta semana.',
  desc: 'Qué fabricar, cómo arrancar sin experiencia y cómo conseguir tus primeros 5 clientes esta semana.',
  check: 'Para arrancar hoy mismo.',
  color: '#4A1B6D',
  icon: Rocket
}, {
  num: 2,
  title: '+500 VERSÍCULOS Y FRASES',
  subtitle: 'Listos para imprimir y usar.',
  desc: 'Promesas bíblicas, frases de aliento y mensajes para niños listos para imprimir, cortar y usar hoy.',
  check: 'El tomo que más venden.',
  color: '#C9A84C',
  icon: BookOpen
}, {
  num: 3,
  title: 'DISEÑO Y FOTOS CON CELULAR',
  subtitle: 'Fotos de boutique sin estudio.',
  desc: 'Plantillas de etiquetas premium y el sistema exacto para sacar fotos de boutique con tu celular.',
  check: 'Tus frasquitos van a impresionar.',
  color: '#9D6FBF',
  icon: Camera
}, {
  num: 4,
  title: 'MANUAL DE FABRICACIÓN PROFESIONAL',
  subtitle: 'Producí con calidad de boutique.',
  desc: 'El proceso completo paso a paso para producir 20 frasquitos en una tarde con calidad de boutique.',
  check: 'El tomo más práctico.',
  color: '#C9A84C',
  icon: Factory
}, {
  num: 5,
  title: 'COSTOS Y PRECIOS ANTI-INFLACIÓN',
  subtitle: 'Que la inflación no te coma la ganancia.',
  desc: 'Calculá tus costos reales y ajustá tus precios cada mes para que la inflación no se coma tu ganancia.',
  check: 'Vital en Argentina.',
  color: '#4A1B6D',
  icon: DollarSign
}, {
  num: 6,
  title: 'CLIENTES Y VENTAS ESCALABLES',
  subtitle: 'De pedidos sueltos a pedidos masivos.',
  desc: 'Cómo pasar de vender frascos sueltos a pedidos masivos en iglesias, ferias y red de revendedoras.',
  check: 'La guía que hace el negocio escalable.',
  color: '#C9A84C',
  icon: TrendingUp
}];
const includes = ['Sistema listo para implementar desde el día 1', 'Plantillas y modelos listos para copiar y adaptar', 'Estrategias específicas para Argentina', 'Lenguaje 100% rioplatense', 'Fe cristiana integrada', 'Precios y proveedores actualizados', '100% orientado a resultados'];
export function TomosGrid() {
  return <section className="py-20 px-4 bg-brand-base border-t border-white/5 relative overflow-hidden" data-id="element-317">
      <div className="absolute top-20 left-1/2 -translate-x-1/2 w-[400px] h-[200px] bg-brand-gold/10 blur-3xl rounded-full pointer-events-none" data-id="element-318"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-purple/10 blur-[120px] rounded-full pointer-events-none" data-id="element-319"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-320">
        <div className="mb-16" data-id="element-321">
          <p className="text-brand-green font-bold tracking-widest uppercase text-sm mb-4 flex items-center justify-center gap-2" data-id="element-322">
            MEGAPACK EMPRENDE CON DIOS™
          </p>
          <h2 className="text-3xl sm:text-5xl font-extrabold text-white mb-6 relative inline-block" data-id="element-323">
            6 TOMOS MAESTROS
          </h2>
          <p className="text-xl font-medium text-gray-300" data-id="element-324">
            6 Tomos + 6 Bonos — Edición 2026 Argentina
          </p>
          <p className="mt-3 inline-block bg-gradient-to-r from-yellow-500 via-yellow-300 to-yellow-500 bg-clip-text font-extrabold tracking-wide drop-shadow-[0_0_15px_rgba(250,204,21,0.3)] text-brand-gold text-[20px]" data-id="element-325">
            +420 páginas — Todo resuelto. Listo para usar desde hoy.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-326">
          {tomos.map((tomo, i) => {
          const Icon = tomo.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 shadow-lg flex flex-col items-center h-full border border-white/10 relative overflow-hidden pt-[32px] pb-[32px] pl-[3px] pr-[3px]" style={{
            borderTop: `4px solid ${tomo.color}`
          }} data-id="element-327">
                <div className="w-16 h-16 rounded-2xl flex items-center justify-center text-white shadow-md mb-5" style={{
              backgroundColor: tomo.color
            }} data-id="element-328">
                  <Icon size={30} data-id="element-329" />
                </div>

                <p className="text-xs font-bold text-gray-500 uppercase tracking-widest mb-2" data-id="element-330">
                  Tomo {tomo.num}
                </p>

                <h3 className="text-xl font-extrabold mb-2 leading-tight text-[#FAFAF7]" data-id="element-331">
                  {tomo.title}
                </h3>
                <p className="font-bold text-gray-300 mb-4 italic" data-id="element-332">
                  {tomo.subtitle}
                </p>

                <p className="text-gray-400 text-sm leading-relaxed mb-6 flex-grow" data-id="element-333">
                  {tomo.desc}
                </p>

                <div className="pt-4 border-t border-white/10 w-full flex items-center justify-center gap-2 mt-auto" data-id="element-334">
                  <Check size={18} style={{
                color: tomo.color
              }} className="shrink-0" strokeWidth={3} data-id="element-335" />
                  <span className="text-sm font-bold text-white" data-id="element-336">
                    {tomo.check}
                  </span>
                </div>
              </motion.div>;
        })}
        </div>

        <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 sm:p-12 max-w-4xl mx-auto border border-white/10 pt-[3px] pb-[3px]" data-id="element-337">
          <h3 className="text-2xl font-bold text-white mb-8" data-id="element-338">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-8" data-id="element-339">
            {includes.map((item, i) => <div key={i} className="flex items-start gap-3 text-left" data-id="element-340">
                <div className="bg-brand-green/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-341">
                  <Check size={16} className="text-brand-green" strokeWidth={3} data-id="element-342" />
                </div>
                <span className="text-gray-200 font-medium" data-id="element-343">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}